/* eslint-disable no-console */
import { Component } from "@angular/core";
import { UiPlacementType } from "@webapp/ui/dropdown/models/dropdown.models";
@Component({
  selector: "gh-example-dropdown-component",
  templateUrl: "./example-dropdown.component.html",
  styleUrls: ["./example-dropdown.component.less"],
})
export class ExampleDropdownComponent {
  public listOfPosition: UiPlacementType[] = ["bottomLeft", "bottomCenter", "bottomRight", "topLeft", "topCenter", "topRight"];

  public change(value): void {
    console.log(value);
  }

  public log(): void {
    console.log("click dropdown button");
  }
}
